import moment from "moment";
import "moment-timezone";

export const parseTime = function (time) {
	const values = (time || "").split(":");
	if (values.length >= 2) {
		const hours = parseInt(values[0], 10);
		const minutes = parseInt(values[1], 10);

		return {
			hours,
			minutes,
		};
	}

	return null;
};
export const compareTime = function (time1, time2) {
	const value1 = parseTime(time1);
	const value2 = parseTime(time2);

	const minutes1 = value1.minutes + value1.hours * 60;
	const minutes2 = value2.minutes + value2.hours * 60;

	if (minutes1 === minutes2) {
		return 0;
	}

	return minutes1 > minutes2 ? 1 : -1;
};
export const timeInMinutes = function (time1) {
	const value1 = parseTime(time1);

	const minutes1 = value1.minutes + value1.hours * 60;

	return minutes1;
};
export const difTimeInMinutes = function (time1, time2) {
	const value1 = parseTime(time1);
	const value2 = parseTime(time2);

	const minutes1 = value1.minutes + value1.hours * 60;
	const minutes2 = value2.minutes + value2.hours * 60;

	if (minutes1 === minutes2) {
		return 0;
	}

	return minutes1 - minutes2;
};
export const difTime = function (time1, time2) {
	const resT = difTimeInMinutes(time1, time2);
	let resm = resT % 60;
	let resh = (resT - resm) / 60;
	let neg = false;
	if (resm < 0) {
		resm = resm * -1;
		neg = true;
	}
	if (resh < 0) {
		resh = resh * -1;
		neg = true;
	}
	return formatTime({ hours: resh, minutes: resm }, neg);
};

// TODO: refactor this two function in one like TimeH
export const formatTime = function (time, neg = false) {
	return `${(neg ? "+" : "") + (time.hours < 10 ? `0${time.hours}` : time.hours)}:${time.minutes < 10 ? `0${time.minutes}` : time.minutes}`;
};
export const formatTimeH = function (time, h = "H") {
	return (time.hours < 10 ? `0${time.hours}` : time.hours) + h + (time.minutes < 10 ? `0${time.minutes}` : time.minutes);
};

export const nextTime = function (time, step, fact = 1) {
	const timeValue = parseTime(time);
	const stepValue = parseTime(step);

	const next = {
		hours: timeValue.hours,
		minutes: timeValue.minutes,
	};

	next.minutes += stepValue.minutes * fact;
	next.hours += stepValue.hours * fact;

	next.hours += Math.floor(next.minutes / 60);
	next.minutes = next.minutes % 60;

	return formatTime(next);
};

export const previousTime = function (time, step, fact = 1) {
	const timeValue = parseTime(time);
	const stepValue = parseTime(step);

	const next = {
		hours: timeValue.hours,
		minutes: timeValue.minutes,
	};
	let subHour = false;
	if (stepValue.minutes > next.minutes) subHour = true;

	next.minutes -= stepValue.minutes * fact;
	next.hours -= stepValue.hours * fact;

	next.hours += Math.floor(next.minutes / 60);
	// if (next.minutes < 0) next.minutes *= -1
	if (subHour) {
		next.minutes *= -1;
		next.minutes = 60 - (next.minutes % 60);
	} else next.minutes = next.minutes % 60;
	return formatTime(next);
};

export const arrayOfTimestamp = function (startDate, endDate) {
	let tsArray = [];
	// dates
	let dateMin = new Date(startDate);
	let dateMax = new Date(endDate);
	// timestamps
	let minTS = dateToTimeStamp(dateMin.getDate(), dateMin.getMonth(), dateMin.getFullYear());
	let maxTS = dateToTimeStamp(dateMax.getDate(), dateMax.getMonth(), dateMax.getFullYear());
	let tsSaver = minTS;
	// get all dates
	while (tsSaver <= maxTS) {
		tsArray.push(tsSaver);
		let tmp = new Date(tsSaver);
		tmp.setDate(tmp.getDate() + 1);
		tsSaver = dateToTimeStamp(tmp.getDate(), tmp.getMonth(), tmp.getFullYear());
	}
	return tsArray;
};

export const dateIntervalToTimeStamp = function (startDate, endDate) {
	let dateMin = new Date(startDate);
	let dateMax = new Date(endDate);

	let startDateTs = dateToTimeStamp(dateMin.getDate(), dateMin.getMonth(), dateMin.getFullYear());
	let endDateTs = dateToTimeStamp(dateMax.getDate(), dateMax.getMonth(), dateMax.getFullYear());

	return {
		startDateTs,
		endDateTs,
	};
};

export const arrayOfTimestampCheckDays = function (startDate, endDate, idDay) {
	let tsArray = [];
	// dates
	let dateMin = new Date(startDate);
	let dateMax = new Date(endDate);
	// timestamps
	let minTS = dateToTimeStamp(dateMin.getDate(), dateMin.getMonth(), dateMin.getFullYear());
	let maxTS = dateToTimeStamp(dateMax.getDate(), dateMax.getMonth(), dateMax.getFullYear());
	let tsSaver = minTS;
	// get all dates
	while (tsSaver <= maxTS) {
		let tmp = new Date(tsSaver);
		if (tmp.getDay() === idDay) tsArray.push(tsSaver);
		tmp.setDate(tmp.getDate() + 1);
		tsSaver = dateToTimeStamp(tmp.getDate(), tmp.getMonth(), tmp.getFullYear());
	}
	return tsArray;
};

export const dateToTimeStamp = function (date, month, year) {
	// get date UTC
	let dUTC = new Date(Date.UTC(year, month, date, 0, 0, 0, 0));

	let m = moment(dUTC).tz("Europe/Paris");
	let tzOffset = m._offset * 60000;

	// calc new date with out timezone
	let newDate = new Date(dUTC.getTime() - tzOffset);

	return newDate.getTime();
};

export const dateToTimeStampHourMinutes = function (date, month, year, hour, minutes) {
	// get date UTC
	let dUTC = new Date(Date.UTC(year, month, date, hour, minutes, 0, 0));

	let m = moment(dUTC).tz("Europe/Paris");
	let tzOffset = m._offset * 60000;

	// calc new date with out timezone
	let newDate = new Date(dUTC.getTime() - tzOffset);

	return newDate.getTime();
};

export const timeStampToDateString = function (ts) {
	const d = new Date(ts);
	const jour = String(d.getDate()).padStart(2, "0");
	const mois = String(d.getMonth() + 1).padStart(2, "0");
	const annee = d.getFullYear();

	return `${jour}/${mois}/${annee}`;
};

export const formatDateDayMonthYear = (date) => {
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${day}-${month}-${year}`;
};
